import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTheme, useMediaQuery, CircularProgress, Icon, Paper, Typography, Divider } from '@material-ui/core'
import Timeline from '@material-ui/lab/Timeline'
import TimelineItem from '@material-ui/lab/TimelineItem'
import TimelineSeparator from '@material-ui/lab/TimelineSeparator'
import TimelineConnector from '@material-ui/lab/TimelineConnector'
import TimelineContent from '@material-ui/lab/TimelineContent'
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent'
import TimelineDot from '@material-ui/lab/TimelineDot'
import moment from 'moment'
import localization from 'moment/locale/pt-br'

import { useVestigioService } from 'hooks/useVestigioService'
import { useStyles } from './TimeLineCadeiDeCustodia.styles'
import { popularTimeLine } from './timelineCadeiaHelper'

export const TimeLineCadeiaDeCustodia = (props) => {
  const { idVestigio } = props
  const vestigioService = useVestigioService()
  const classes = useStyles()
  moment.locale('pt-br', localization)

  const [acoes, setAcoes] = useState([])
  const [processando, setProcessando] = useState(false)
  const vestigioTimeLine = useSelector((state) => state.vestigio.vestigioTimeLine)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  useEffect(() => {
    if (idVestigio) {
      vestigioService.listarVestigioTimeline(idVestigio, setProcessando)
    }
  }, [idVestigio])

  useEffect(() => {
    if (vestigioTimeLine && vestigioTimeLine.id) {
      setAcoes(popularTimeLine(vestigioTimeLine))
    }
  }, [vestigioTimeLine])

  return (
    <div className={classes.root}>
      {processando ? (
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px' }}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        vestigioTimeLine && (
          <div style={{ display: 'flex', flexDirection: 'column' }}>

            <Timeline className={classes.timeline} align={isMobile ? 'left' : 'alternate'}>
              {acoes.map((acaoVestigio, index) => (
                <TimelineItem key={acaoVestigio.id || index}>
                  {!isMobile && (
                    <TimelineOppositeContent>
                      <Typography variant="body2" color="textSecondary">
                        {acaoVestigio.textData}
                        <br />
                        {moment(acaoVestigio.data).isValid() ? moment(acaoVestigio.data).format('LLLL') : '-'}
                      </Typography>
                    </TimelineOppositeContent>
                  )}
                  <TimelineSeparator>
                    <TimelineDot color={acaoVestigio.color === 'secondary' ? 'secondary' : 'primary'}>
                      <Icon className={acaoVestigio.icon} style={{ fontSize: 20 }} />
                    </TimelineDot>
                    {index < acoes.length - 1 ? <TimelineConnector /> : ''}
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3} className={classes.paper}>
                      {isMobile && (
                        <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginBottom: '8px' }}>
                          {acaoVestigio.textData}: {moment(acaoVestigio.data).isValid() ? moment(acaoVestigio.data).format('DD/MM/YYYY HH:mm') : '-'}
                        </Typography>
                      )}
                      <Typography className={classes.cardTitle} component="h2">
                        {acaoVestigio.tipo}
                      </Typography>
                      <div>
                        {acaoVestigio.itens.map((dado, i) => {
                          if (dado === '___') {
                            return <Divider key={i} className={classes.divider} />
                          }
                          return (
                            <Typography key={i} className={classes.cardItem} variant="body2">
                              {dado}
                            </Typography>
                          )
                        })}
                      </div>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              ))}
            </Timeline>
          </div>
        )
      )}
    </div>
  )
}
